import {IonButton, IonContent, IonPage} from '@ionic/react';
import React, {useEffect} from 'react';
import {removeLocalOrSessionStateItem} from "../services/LocalState";
import {RouteComponentProps} from "react-router";

interface ErrorRouteInterface extends RouteComponentProps<{
    shopId?: string;
    id?: string;
}> {
}

const Error: React.FC<ErrorRouteInterface> = ({match}) => {
    const currentShopId = match.params.shopId !== undefined ? parseInt(match.params.shopId) : null;
    const errorCode = match.params.id !== undefined ? match.params.id : '404';

    useEffect(() => {
        if (errorCode === '142') {
            removeLocalOrSessionStateItem("shopCustomerIdStore");
            removeLocalOrSessionStateItem("customerSessionTokenStore");
            removeLocalOrSessionStateItem("currentSessionToken");
        }
    }, [errorCode]);

    return (
        <IonPage className={"error"}>
            <IonContent>
                <div className={"ion-padding"}>
                    <h1>Fout</h1>

                    {errorCode === '404' && (
                        <p>De opgevraagde data kan voor u niet gevonden worden.</p>
                    )}

                    {errorCode === '503' && (
                        <p>Probeer het over enkele minuten opnieuw.</p>
                    )}

                    {errorCode === '142' && (
                        <p>Authenticatieprobleem, log alstublieft opnieuw in.</p>
                    )}

                    {errorCode === 'network' && (
                        <p>Verbindingsprobleem, controleer alstublieft uw internetverbinding.</p>
                    )}

                    {errorCode === 'page-not-found' && (
                        <p>De pagina kan niet geladen worden.</p>
                    )}

                    {errorCode !== '404' && errorCode !== '503' && errorCode !== 'network' && errorCode !== 'page-not-found' && errorCode !== '142' && (
                        <p>Er heeft zich een onbekende fout voorgedaan.</p>
                    )}

                    {errorCode !== '503' && errorCode !== '142' && errorCode !== 'page-not-found' && (
                        <p>Probeer het opnieuw of sluit de app eerst helemaal af en probeer het dan nog eens.</p>
                    )}

                    <p>Als u herhaaldelijk deze foutmelding krijgt en u zelf de oorzaak niet kan achterhalen graag
                        contact opnemen met uw gemeente.</p>

                    <p style={{color: "grey"}}><em>(Foutcode: {errorCode})</em></p>
                </div>

                {currentShopId === null && (
                    <IonButton className={"largeButton"} expand={"block"} href="/">Terug
                        naar startpagina</IonButton>
                )}
            </IonContent>
        </IonPage>
    )
}

export default Error;